/* eslint-disable @typescript-eslint/no-explicit-any */

import { createContext, useContext } from 'react';

export const NavigationContext = createContext<{ offset: number; navRef: any }>({ offset: 0, navRef: null });

export const useNavContext = () => {
  return useContext(NavigationContext);
};
